<template>
  <BaseSelect :value="value"
              class="accounts-select"
              :options="selectOptions"
              :select-label="label"
              label="title"
              track-by="id"
              :group-label="displayGrouped ? 'title' : ''"
              :group-values="displayGrouped ? 'childs' : ''"
              :group-select="false"
              :allow-empty="false"
              :searchable="true"
              :show-labels="false"
              :disabled="disabled"
              @input="$emit('input',$event)"
              @open="$emit('open')">
    <template v-slot:option="props">
      <span v-if="props.option.$isLabel && props.option.$groupLabel" class="group-label">{{ props.option.$groupLabel }}</span>
      <span v-else-if="!props.option.$isLabel">{{ props.option.title }}</span>
    </template>
    <template v-slot:noOptions="">
      <div class="w-full whitespace-normal">
        <slot name="noOptions">
          {{ $t('noAccounts') }}
          <router-link :to="{name:'settings-accounts'}" class="text-red">{{ $t('here') }}</router-link>
        </slot>
      </div>
    </template>
    <template v-slot:errors="">
      <slot name="errors"></slot>
    </template>
  </BaseSelect>
</template>
<script>

import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";

export default {
  name: "AccountsSelect",
  components: {BaseSelect},
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      required: true
    },
    grouped: {
      type: Boolean,
      required: true
    },
    accounts: {
      type: Array,
      required: true
    },
    account_groups: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * exclude — новая операция: скрытые счета не показываем
     * keep-selected — редактирование: оставляем текущий счёт, даже если он скрыт
     * group — остальные селекты: скрытые в группе «Скрытые» внизу
     */
    hiddenMode: {
      type: String,
      default: 'group',
      validator: (val) => ['exclude', 'keep-selected', 'group'].includes(val)
    }
  },
  computed: {
    selectedId() {
      return this.value && this.value.id != null ? this.value.id : null
    },
    hiddenAccounts() {
      if (this.hiddenMode !== 'group') {
        return []
      }
      return this.accounts.filter(acc => this.isHiddenAccount(acc))
    },
    visibleAccounts() {
      return this.accounts.filter(acc => this.isVisibleAccount(acc))
    },
    displayGrouped() {
      return this.grouped || this.hiddenAccounts.length > 0
    },
    selectOptions() {
      if (!this.displayGrouped) {
        return this.visibleAccounts
      }
      return this.selectGroups
    },
    selectGroups() {
      let groups
      if (this.grouped) {
        groups = this.account_groups
            .map(group => ({
              ...group,
              childs: (group.childs || []).filter(acc => this.isVisibleAccount(acc))
            }))
            .filter(group => group.childs.length > 0)
      } else {
        groups = [{
          id: '__visible__',
          title: '',
          childs: this.visibleAccounts
        }].filter(group => group.childs.length > 0)
      }
      if (this.hiddenAccounts.length) {
        groups = [...groups, {
          id: '__hidden__',
          title: this.$t('hiddenGroup'),
          childs: this.hiddenAccounts
        }]
      }
      return groups
    }
  },
  methods: {
    isHiddenAccount(acc) {
      return !!acc && acc.id != null && !!acc.is_hidden
    },
    isVisibleAccount(acc) {
      if (!this.isHiddenAccount(acc)) {
        return true
      }
      return this.hiddenMode === 'keep-selected' && acc.id === this.selectedId
    }
  },
  i18n: {
    messages: {
      en: {
        noAccounts: 'You don\'t have any created accounts yet, you can add them',
        here: 'here',
        hiddenGroup: 'Hidden'
      },
      ru: {
        noAccounts: 'У вас пока нет сформированных счетов, вы можете добавить их',
        here: 'здесь',
        hiddenGroup: 'Скрытые'
      }
    }
  }
}
</script>
<style scoped lang="scss">
.accounts-select {
  ::v-deep .multiselect__option--group:not(:has(.group-label)) {
    display: none;
    height: 0;
    min-height: 0;
    padding: 0;
    overflow: hidden;
    pointer-events: none;
  }
}
</style>
